import styles from './LoginPage.module.scss';
import React, { useContext, useState } from 'react';
import { AuthContext } from '../../context/authContext';
import { useNavigate } from 'react-router-dom';
import http from '../../components/http';

// Interface para os dados de login
interface LoginData {
  email: string;
  senha: string;
}

const LoginPage: React.FC = () => {
  const authContext = useContext(AuthContext);
  if (!authContext) throw new Error('AuthContext must be used within an AuthProvider');

  const { login } = authContext;
  const [email, setEmail] = useState<string>('');
  const [senha, setSenha] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  // Função para lidar com o login
  const handleLogin = async () => {
    setLoading(true);
    setError(null);

    const loginData: LoginData = { email, senha };

    try {
      // Envia a requisição de login para o backend
      const res = await http.post('/usuarios/login', loginData);
      const { usuario } = res.data;

      // Verifica se o login foi bem-sucedido
      if (usuario) {
        login({ id: usuario.id, nome: usuario.nome });
        navigate('/home', { replace: true });
      } else {
        setError('Email ou senha inválidos!');
      }
    } catch (error) {
      setError('Erro ao realizar o login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Senha"
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
      />
      <button onClick={handleLogin} disabled={loading}>
        {loading ? 'Entrando...' : 'Entrar'}
      </button>
    </div>
  );
};

export default LoginPage;
